module.exports = __webpack_public_path__ + "assets/img/title-a087328b.png";